import React from "react"
import type { BlogCardsType } from "types/cms"
import {
  BlogArticleCard,
  BlogArticleCardV2,
} from "components/Blog/SharedComponents/BlogArticleCard"
import { Button } from "packages/ui-shared/components/Button/Button"
import {
  blogCardsTitle,
  blogCardsContainerColors,
  scrollElement,
  blogCardsContent,
  blogCardsLink,
  blogCardsButton,
} from "./BlogCards.css"

type Props = BlogCardsType

export const BlogCards: React.FC<Props> = ({
  title,
  cta,
  backgroundColour,
  trackingModule,
  crossSpaceArticles,
}) => {
  const getColourVariant = backgroundColour?.replace(/\s+/g, "") as string

  return (
    <div className={blogCardsContainerColors[getColourVariant]}>
      <h3 className={blogCardsTitle}>{title}</h3>
      <div className={scrollElement} id="scroll">
        <div className={blogCardsContent}>
          {crossSpaceArticles.map((article) => {
            if ("__typename" in article) {
              return <BlogArticleCardV2 key={article.id} article={article} />
            }
            const articleToPass = {
              ...article,
              heroImage: {
                fields: { ...article.heroImage },
              },
            }
            return (
              <BlogArticleCard
                key={article.id}
                post={articleToPass as any}
                tag={article.tags[0] as any}
                tagFontVariant="acuminMedium"
                headingSize="h4"
                minHeightForce
              />
            )
          })}
        </div>
      </div>
      {cta && (
        <a className={blogCardsLink} href={cta.link}>
          <Button
            className={blogCardsButton}
            variant="primary"
            {...cta}
            {...trackingModule}
          >
            {cta.title}
          </Button>
        </a>
      )}
    </div>
  )
}
